// Generated by Melange

import InputModuleCss from "./input.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = InputModuleCss;

function Input(Props) {
  let autoComplete = Props.autoComplete;
  let autoFocus = Props.autoFocus;
  let defaultValue = Props.defaultValue;
  let disabled = Props.disabled;
  let id = Props.id;
  let name = Props.name;
  let required = Props.required;
  let type_ = Props.type_;
  let tmp = {
    className: css.root
  };
  if (defaultValue !== undefined) {
    tmp.defaultValue = Caml_option.valFromOption(defaultValue);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (autoComplete !== undefined) {
    tmp.autoComplete = Caml_option.valFromOption(autoComplete);
  }
  if (autoFocus !== undefined) {
    tmp.autoFocus = Caml_option.valFromOption(autoFocus);
  }
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  if (name !== undefined) {
    tmp.name = Caml_option.valFromOption(name);
  }
  if (required !== undefined) {
    tmp.required = Caml_option.valFromOption(required);
  }
  if (type_ !== undefined) {
    tmp.type = Caml_option.valFromOption(type_);
  }
  return JsxRuntime.jsx("input", tmp);
}

const make = Input;

export {
  make,
}
/* css Not a pure module */
